export const sexOffendersTableColumns = [
    {
        field: 'fullName',
        headerName: 'Offender Name',
        width: 162,
        isAlert: true
    },
    {
        field: 'sex_offender_changes',
        headerName: 'Address',
        width: 162,
    },
    {
        field: 'sex_offender_race',
        headerName: 'Race',
        width: 162,
    },
    {
        field: 'sex_offender_birthdate',
        headerName: 'Date of Birth',
        width: 162,
    },
    {
        field: 'sex_offender_height',
        headerName: 'Height',
        width: 162,
    },
    {
        field: 'sex_offender_weight',
        headerName: 'Weight',
        width: 162,
    },
    {
        field: 'sex_offender_sex',
        headerName: 'Gender',
        width: 162,
    },
    {
        field: 'sex_offender_age',
        headerName: 'Age',
        width: 162,
    },
    {
        field: 'sex_offender_hair',
        headerName: 'Hair Color',
        width: 162,
    },
    {
        field: 'sex_offender_eyes',
        headerName: 'Eye Color',
        width: 162,
    },
    {
        field: 'sex_offender_marks',
        headerName: 'Marks',
        width: 162,
    },
    {
        field: 'sex_offender_aliases',
        headerName: 'Aliases',
        width: 162,
    },
    {
        field: 'sex_offender_is_predator',
        headerName: 'Is Predator',
        width: 325.5,
        isAlert: true,
        tooltipText:'Flagged as a predator due to the severity of offenses or legal classification, indicating a higher risk of repeat offenses'
    },
    {
        field: 'sex_offender_is_absconder',
        headerName: 'Is Absconder',
        width: 325.5,
        isAlert: true,
        tooltipText:'Flagged as an absconder for failing to comply with registration requirements or evading law enforcement'
    },
    {
        field: 'sex_offender_charges',
        headerName: 'Offense',
        width: 670,
        isAlert: true
    }
]